import { stripTags as g } from "../../../../../../services/strings/index.js";
import { getPelandoLoadingGif as o } from "../../../../../../services/url/index.js";
const h = (e) => {
  let a, t;
  const m = /<img\s+[^>]*>/g, s = e.match(m);
  return s ? (a = !!s.find((r) => {
    const i = r.match(/\<img.+src\=(?:\"|\')(.+?)(?:\"|\')(?:.+?)\>/);
    return i && i[1].match(o());
  }), t = !0) : t = /\S/.test(g(e).replace(/&nbsp;/g, "")), !a && t;
};
export {
  h as isSubmittableValue
};
